export default __webpack_public_path__ + "static/media/15.084ad4bf.jpg";